module.exports = __webpack_public_path__ + "media/images/icon__ranking@2x-cc882e94332414140455832ce2567eaf.png";